<div class="mx-4 mt-3 mb-5 pt-5 box-border">
  <h2 class="title-container mt-0">Chart Rendering Options</h2>
  @if (markLinesAndScale) {
    <div class="slide-options flex-it">
      <mat-slide-toggle
        labelPosition="before"
        [(ngModel)]="render.scale"
        (change)="setRender()"
        class="mr-5"
      >
        Max Scale
      </mat-slide-toggle>
      <mat-slide-toggle
        labelPosition="before"
        [(ngModel)]="render.lines"
        (change)="setRender()"
        class="ml-5"
      >
        Marklines
      </mat-slide-toggle>
    </div>
  }
  @if (coOccurPercentageOption) {
    <div class="slide-options flex-it">
      <mat-slide-toggle [(ngModel)]="render.percentage" (change)="setRender()"
        >Co-Occurrence % (B in A)</mat-slide-toggle
      >
    </div>
  }
</div>
